import { pathOr } from 'ramda';

import {
  getPackItemSize,
  PackItem,
  setPackItemPrice,
  setPackItemSize
} from '@/models/core/PackItem';
import { getSizeUnits, Price, Size } from '@/models/core/values';
import { ProductPack } from '@/models/core/ProductPack';
import { CartItem } from '@/models/core/CartItem';
import { getSerumProductPacks } from '@/models/back-end/Treatment';

import { PRODUCT_REFERENCES } from '@/constants/treatment';

const getFreeSampleQuantity = validationPageData => {
  const products = pathOr([], ['treatmentDetailsDto', 'sample', 'products'], validationPageData);

  return products.reduce((acc, product) => {
    return acc + pathOr(0, ['multiplier'], product);
  }, 0);
};

export const getListOfBoughtCartItems = validationPageData => {
  const { currency } = validationPageData;
  const { treatmentDetailsDto: treatmentDetails, country } = validationPageData;

  // `country` is the delivery country on the validation-page dto; pass it as
  // `customerCountryCode` so kojic concentration (1% non-US/CA, 2% US/CA) is
  // displayed correctly on the order-validation summary.
  const serumCartItems = getSerumProductPacks(
    { treatmentDetails, customerCountryCode: country },
    true,
    currency
  ).map(pack => CartItem(pack, 1));

  const cleanse = pathOr([], ['cleanse', 'products'], treatmentDetails);
  const moisturize = pathOr([], ['moisturize', 'products'], treatmentDetails);
  const protect = pathOr([], ['protect', 'products'], treatmentDetails);

  const complementaryCartItems = [...cleanse, ...moisturize, ...protect].map(config => {
    let item = PackItem({ reference: config.name, usage: config.usage });

    const defaultSize = getPackItemSize(item);
    const boughtSize = Size(+config.size, getSizeUnits(defaultSize));

    item = setPackItemSize(boughtSize, item);
    item = setPackItemPrice(Price(config.price, currency), item);

    return CartItem(ProductPack([item]), config.orderMultiplier);
  });

  const freeSampleQuantity = getFreeSampleQuantity(validationPageData);

  if (freeSampleQuantity) {
    const freeSamplePack = ProductPack([
      PackItem({ reference: PRODUCT_REFERENCES.FREE_SAMPLE, price: Price(0, currency) })
    ]);

    const freeSampleCartItem = CartItem(freeSamplePack, freeSampleQuantity);

    return [...serumCartItems, ...complementaryCartItems, freeSampleCartItem];
  }

  return [...serumCartItems, ...complementaryCartItems];
};
